import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import {
    IconButton,
    InputAdornment,
    TextField,
    TextFieldProps,
} from '@material-ui/core';

export const PasswordInput = (props: TextFieldProps) => {
    const [passwordVisibility, setPasswordVisibility] = useState(false);

    const passwordProps = {
        InputProps: {
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label="Toggle password visibility"
                        onClick={() =>
                            setPasswordVisibility(!passwordVisibility)
                        }
                    >
                        {passwordVisibility ? (
                            <FontAwesomeIcon icon={faEyeSlash} />
                        ) : (
                            <FontAwesomeIcon icon={faEye} />
                        )}
                    </IconButton>
                </InputAdornment>
            ),
        },
    };
    return (
        <TextField
            fullWidth
            {...props}
            {...passwordProps}
            type={passwordVisibility ? 'text' : 'password'}
        />
    );
};
